import { ServiceId, ActionId, ActionCallId } from './types';

export enum StreamEventType {
  ChunkReceived,
  StreamComplete,
  StreamError,
}

export interface StreamChunk<T = any> {
  type: StreamEventType;
  data?: T;
  error?: Error;
  isComplete?: boolean;
}

export type StreamActionResponse<T = any> = {
  actionCallId: ActionCallId;
  serviceId: ServiceId;
  actionId: ActionId;
  chunk: StreamChunk<T>;
};

export type StreamListener<T = any> = (chunk: StreamChunk<T>) => void;

export interface StreamController {
  cancel: () => Promise<void>;
}
